import { Trans } from '@lingui/react';
import { Stack } from '@startuptools/ui/Stack';
import { Tab, tabClasses } from '@startuptools/ui/Tab';
import { TabList } from '@startuptools/ui/TabList';
import { Tabs } from '@startuptools/ui/Tabs';
import { Suspense } from 'react';
import { Link, Outlet, Routes, useLocation } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { BoardMeetingMembers } from './BoardMeetingMembers';
import { BoardMeetingTemplates } from './BoardMeetingTemplates';
import { BoardMeetingFrequency } from './BoardMeetingFrequency';

const BoardSettings = () => {
  const location = useLocation();
  const tabValue = location.pathname.split('/').at(-1);

  return (
    <Stack gap={3}>
      <Tabs value={tabValue}>
        <TabList
          size="lg"
          disableUnderline
          sx={theme => ({
            p: 0.5,
            gap: 0.5,
            borderRadius: 'lg',
            bgcolor: 'background.level1',
            [`& .${tabClasses.root}[aria-selected="true"]`]: {
              boxShadow: 'sm',
              bgcolor: 'background.surface',
              color: theme.palette.primary[500],
            },
          })}
        >
          <Link to="../members" relative="path">
            <Tab disableIndicator value="members">
              <Trans id="Members" />
            </Tab>
          </Link>

          <Link to="../meeting-frequency" relative="path">
            <Tab disableIndicator value="meeting-frequency">
              <Trans id="Meeting Frequency" />
            </Tab>
          </Link>

          <Link to="../meeting-templates" relative="path">
            <Tab disableIndicator value="meeting-templates">
              <Trans id="Meeting Templates" />
            </Tab>
          </Link>
        </TabList>
      </Tabs>

      <Suspense>
        <Outlet />
      </Suspense>
    </Stack>
  );
};

export const BoardSettingsRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<BoardSettings />}>
        <Route index path="members" element={<BoardMeetingMembers />} />
        <Route path="meeting-frequency" element={<BoardMeetingFrequency />} />
        <Route path="meeting-templates" element={<BoardMeetingTemplates />} />
      </Route>
    </Routes>
  );
};
